import { Building } from './types';
import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';

export const buildingState = (state: RootState): RootState['building'] => state.building;

export const building = createSelector(buildingState, (state: RootState['building']): Building | null => state.data);
